(() => {
  const enhance = (root = document) => {
    root.querySelectorAll('.rs-mobile-header').forEach(header => {
      if (header.dataset.rsMobileReady) return;
      header.dataset.rsMobileReady = 'true';
      const drawer = header.querySelector('.rs-mobile-drawer');
      const toggle = header.querySelector('.rs-mobile-toggle');
      const close = () => { if (drawer.open) drawer.close(); };
      toggle.addEventListener('click', () => {
        if (drawer.open) return;
        drawer.showModal();
        drawer.scrollTop = 0;
        toggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add('rs-mobile-menu-open');
        drawer.querySelector('.rs-mobile-close').focus({ preventScroll: true });
      });
      header.querySelector('.rs-mobile-close').addEventListener('click', close);
      drawer.addEventListener('close', () => {
        toggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('rs-mobile-menu-open');
        if (matchMedia('(max-width: 959px)').matches) toggle.focus({ preventScroll: true });
      });
      drawer.addEventListener('click', event => {
        const box = drawer.getBoundingClientRect();
        if (event.target === drawer && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) close();
        if (event.target.closest('a[href]')) close();
      });
      matchMedia('(min-width: 960px)').addEventListener('change', event => { if (event.matches) close(); });
    });
    root.querySelectorAll('.rs-footer-group').forEach(group => {
      if (group.dataset.rsFooterReady) return;
      group.dataset.rsFooterReady = 'true';
      const compact = matchMedia('(max-width: 600px)');
      const summary = group.querySelector('summary');
      const sync = () => {
        group.open = !compact.matches;
        summary.tabIndex = compact.matches ? 0 : -1;
        summary.setAttribute('aria-disabled', String(!compact.matches));
      };
      sync();
      compact.addEventListener('change', sync);
      summary.addEventListener('click', event => { if (!compact.matches) event.preventDefault(); });
    });
    root.querySelectorAll('.rs-picture-menu, .rs-explore').forEach(menu => {
      if (menu.dataset.rsReady) return;
      menu.dataset.rsReady = 'true';
      const tabs = Array.from(menu.querySelectorAll('.rs-menu-category'));
      const selectCategory = (selected, focus = false) => {
        tabs.forEach(tab => {
          const active = tab === selected;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          const panel = menu.querySelector('[id="' + tab.getAttribute('aria-controls') + '"]');
          if (panel) panel.hidden = !active;
        });
        if (focus) selected.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectCategory(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); selectCategory(tabs[next], true); }
        });
      });
      let closeTimer;
      const closeOthers = () => document.querySelectorAll('.rs-picture-menu[open], .rs-explore[open]').forEach(other => { if (other !== menu) other.open = false; });
      menu.addEventListener('toggle', () => { if (menu.open) closeOthers(); });
      menu.querySelector('summary').addEventListener('click', event => {
        if (menu.classList.contains('rs-picture-menu') && event.detail > 0 && matchMedia('(hover: hover) and (pointer: fine)').matches) {
          event.preventDefault();
          closeOthers();
          menu.open = true;
        }
      });
      menu.addEventListener('pointerenter', () => {
        clearTimeout(closeTimer);
        if (menu.classList.contains('rs-picture-menu') && matchMedia('(hover: hover) and (pointer: fine)').matches) {
          closeOthers();
          menu.open = true;
        }
      });
      menu.addEventListener('pointerleave', () => {
        if (matchMedia('(hover: hover) and (pointer: fine)').matches && !menu.contains(document.activeElement)) closeTimer = setTimeout(() => { menu.open = false; }, 240);
      });
      menu.addEventListener('focusout', () => {
        setTimeout(() => { if (!menu.contains(document.activeElement) && !menu.matches(':hover')) menu.open = false; }, 0);
      });
    });
    root.querySelectorAll('.rs-product-section form.add-to-cart-form').forEach(form => {
      const quantity = form.querySelector('.quantity-picker:not(.d-none)');
      const cart = form.querySelector('.add-to-cart__wrapper');
      if (quantity && cart && !cart.parentElement.classList.contains('rs-buy-row')) {
        const row = document.createElement('div');
        row.className = 'rs-buy-row';
        cart.before(row);
        row.append(quantity, cart);
      }
      const subtitle = form.querySelector('.rs-product-subtitle');
      if (subtitle && form.querySelector('[name="option1"]')) {
        form.addEventListener('change', () => {
          const choices = Array.from(form.querySelectorAll('select[name^="option"]')).map(select => select.options[select.selectedIndex]?.textContent.trim()).filter(Boolean);
          if (choices.length) subtitle.textContent = choices.join(' · ');
        });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  let footerDockQueued = false;
  const updateFooterDock = () => {
    footerDockQueued = false;
    const bar = document.querySelector('.rs-footer-bar');
    let offset = 0;
    if (bar) {
      const rect = bar.getBoundingClientRect();
      const previewOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--private-preview-bar-offset')) || 0;
      if (rect.bottom > 0 && rect.top < innerHeight) offset = Math.min(rect.height, Math.max(0, innerHeight - rect.top - previewOffset));
    }
    document.documentElement.style.setProperty('--rs-footer-chat-offset', `${Math.ceil(offset)}px`);
  };
  const queueFooterDock = () => {
    if (footerDockQueued) return;
    footerDockQueued = true;
    requestAnimationFrame(updateFooterDock);
  };
  window.addEventListener('scroll', queueFooterDock, { passive: true });
  window.addEventListener('resize', queueFooterDock);
  window.addEventListener('load', queueFooterDock);
  document.addEventListener('shopify:section:load', queueFooterDock);
  const footerDockObserver = new ResizeObserver(queueFooterDock);
  document.querySelectorAll('.rs-light-footer, .rs-footer-bar').forEach(element => footerDockObserver.observe(element, { box: 'border-box' }));
  queueFooterDock();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.rs-explore[open], .rs-picture-menu[open]').forEach(menu => {menu.open = false; menu.querySelector('summary').focus();});
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.rs-explore[open], .rs-picture-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
})();
